import { render, staticRenderFns } from "./FormTransGood.vue?vue&type=template&id=463182a6&"
import script from "./FormTransGood.vue?vue&type=script&lang=js&"
export * from "./FormTransGood.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports